<template>
  <div class="home" v-if="activeMode">
    <BackButton @click="goBack" />
    <div class="headDeposit">
      <img :src="require(`@/assets/icons/${getImgName(currency)}.svg`)" width="32" />
      <p>
        {{ isCard ? $t("bankCard") : getCurrencyName(currency) }}, <span>{{ currency == "sbp" ? "RUB" : currency }}</span>
      </p>
    </div>
    <!-- Выбор банка для карты РФ -->
    <div class="depositBlock bankSelectBlock" v-if="needBankSelection && !bankStepConfirmed">
      <p class="bankSelectLabel">{{ $t("depositSelectBank") }}</p>
      <div
        v-for="opt in bankOptions"
        :key="opt.value"
        class="bankOption"
        :class="{ active: selectedTypeCard === opt.value }"
        @click="selectedTypeCard = opt.value"
      >
        {{ $t(opt.label) }}
      </div>
      <button class="timeAcceptButton" :class="selectedTypeCard ? 'active' : ''" :disabled="!selectedTypeCard" @click="confirmBankAndGoToAmount">
        <p>{{ $t("continue") }}</p>
      </button>
    </div>
    <div class="depositBlock" v-else-if="!isCardData && !isDepositViaTp">
      <input class="timeInput" v-model="selectedAmount" :placeholder="$t('depositPlaceholder') + 'RUB'" />
      <button class="timeAcceptButton" :class="selectedAmount != '' ? 'active' : ''" @click="goPayment">
        <span class="loader" v-if="isLoader"></span>
        <p v-else>{{ $t("continue") }}</p>
      </button>
    </div>
    <div class="depositViaTp" v-else-if="isDepositViaTp">
      <p class="depositViaTpMessage">{{ depositViaTpData.message }}</p>
      <p class="depositViaTpAmount" v-if="depositViaTpData.summ_display">
        {{ $t("depositCardAmount") }}: <span>{{ depositViaTpData.summ_display }}</span>
      </p>
      <button class="timeAcceptButton active" @click="openDepositViaTpLink">
        <p>{{ $t("depositViaTpPay") }}</p>
      </button>
    </div>
    <div class="cardData" v-else-if="isCardData">
      <div v-if="activeMode?.includes('sbp')">
        <div class="dataBlock qrBlock">
          <!-- Загрузка QR-кода -->
          <div v-if="qrLoading" class="qrLoading">
            <div class="qrLoader"></div>
            <p class="qrLoadingText">{{ $t("qrCreating") }}</p>
          </div>
          <!-- Ошибка создания QR-кода -->
          <div v-else-if="qrError" class="qrError">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="errorIcon">
              <circle cx="12" cy="12" r="10" stroke="#ff3b30" stroke-width="2" />
              <path d="M12 8V12M12 16H12.01" stroke="#ff3b30" stroke-width="2" stroke-linecap="round" />
            </svg>
            <p class="qrErrorText">{{ $t("qrCreateFailed") }}</p>
            <p class="qrErrorSupport">{{ $t("contactSupport") }}</p>
          </div>
          <!-- QR-код готов -->
          <div v-else-if="cardData.sbp_qr" class="qrContainer">
            <img :src="cardData.sbp_qr" class="qrImage" />
            <!-- Кнопка для перехода по ссылке -->
            <button v-if="cardData.sbp_link" @click="openSbpLink" class="sbpLinkButton">
              {{ $t("openPaymentLink") }}
            </button>
          </div>
        </div>
      </div>
      <div class="cardData" v-else>
        <div class="dataBlock" @click="copyText">
          <div class="blockInfo">
            <p class="blockHead">{{ $t("depositCardAmount") }}</p>
            <p class="blockValue">{{ cardData.summ_pay }} {{ !isCard ? currency : "₽" }}</p>
          </div>
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.65 1.75C5.40979 1.75 4.28969 1.75 3.43404 2.18597C2.68139 2.56947 2.06947 3.18139 1.68597 3.93404C1.25 4.78969 1.25 5.90979 1.25 8.15V10.85C1.25 13.0902 1.25 14.2103 1.68597 15.066C2.06947 15.8186 2.68139 16.4305 3.43404 16.814C4.28969 17.25 5.40979 17.25 7.65 17.25H10.35C12.5902 17.25 13.7103 17.25 14.566 16.814C15.3186 16.4305 15.9305 15.8186 16.314 15.066C16.75 14.2103 16.75 13.0902 16.75 10.85V8.15C16.75 5.90979 16.75 4.78969 16.314 3.93404C15.9305 3.18139 15.3186 2.56947 14.566 2.18597C13.7103 1.75 12.5902 1.75 10.35 1.75H7.65Z"
              style="fill: var(--black-to-white)"
              fill-opacity="0.2"
            />
            <path
              d="M17.9999 7.75V10.5C17.9999 13.3003 17.9999 14.7004 17.4549 15.77C16.9755 16.7108 16.2106 17.4757 15.2698 17.955C14.2003 18.5 12.8001 18.5 9.99988 18.5H7.25C7.25 19.1967 7.25 19.5451 7.29329 19.8369C7.55182 21.5797 8.92025 22.9482 10.6631 23.2067C10.9549 23.25 11.3033 23.25 12 23.25H16.35C18.5902 23.25 19.7103 23.25 20.566 22.814C21.3186 22.4305 21.9305 21.8186 22.314 21.066C22.75 20.2103 22.75 19.0902 22.75 16.85V12.5001C22.75 11.8033 22.75 11.4549 22.7067 11.163C22.4481 9.42023 21.0798 8.05186 19.337 7.79331C19.0451 7.75 18.6967 7.75 17.9999 7.75Z"
              style="fill: var(--black-to-white)"
              fill-opacity="0.2"
            />
          </svg>
        </div>
        <div class="dataBlock" @click="copyText">
          <div class="blockInfo">
            <p class="blockHead">{{ !isCard ? $t("depositCardCurrency") : $t("depositCardBank") }}</p>
            <p class="blockValue">{{ !isCard ? currency : cardData.block_card.bank_name }}</p>
          </div>
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.65 1.75C5.40979 1.75 4.28969 1.75 3.43404 2.18597C2.68139 2.56947 2.06947 3.18139 1.68597 3.93404C1.25 4.78969 1.25 5.90979 1.25 8.15V10.85C1.25 13.0902 1.25 14.2103 1.68597 15.066C2.06947 15.8186 2.68139 16.4305 3.43404 16.814C4.28969 17.25 5.40979 17.25 7.65 17.25H10.35C12.5902 17.25 13.7103 17.25 14.566 16.814C15.3186 16.4305 15.9305 15.8186 16.314 15.066C16.75 14.2103 16.75 13.0902 16.75 10.85V8.15C16.75 5.90979 16.75 4.78969 16.314 3.93404C15.9305 3.18139 15.3186 2.56947 14.566 2.18597C13.7103 1.75 12.5902 1.75 10.35 1.75H7.65Z"
              style="fill: var(--black-to-white)"
              fill-opacity="0.2"
            />
            <path
              d="M17.9999 7.75V10.5C17.9999 13.3003 17.9999 14.7004 17.4549 15.77C16.9755 16.7108 16.2106 17.4757 15.2698 17.955C14.2003 18.5 12.8001 18.5 9.99988 18.5H7.25C7.25 19.1967 7.25 19.5451 7.29329 19.8369C7.55182 21.5797 8.92025 22.9482 10.6631 23.2067C10.9549 23.25 11.3033 23.25 12 23.25H16.35C18.5902 23.25 19.7103 23.25 20.566 22.814C21.3186 22.4305 21.9305 21.8186 22.314 21.066C22.75 20.2103 22.75 19.0902 22.75 16.85V12.5001C22.75 11.8033 22.75 11.4549 22.7067 11.163C22.4481 9.42023 21.0798 8.05186 19.337 7.79331C19.0451 7.75 18.6967 7.75 17.9999 7.75Z"
              style="fill: var(--black-to-white)"
              fill-opacity="0.2"
            />
          </svg>
        </div>
        <div class="dataBlock" @click="copyText" v-if="isCard">
          <div class="blockInfo">
            <p class="blockHead">{{ !isCard ? $t("depositCardNetwork") : $t("depositCardNumber") }}</p>
            <p class="blockValue">{{ !isCard ? "TRC20" : cardData.card }}</p>
          </div>
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.65 1.75C5.40979 1.75 4.28969 1.75 3.43404 2.18597C2.68139 2.56947 2.06947 3.18139 1.68597 3.93404C1.25 4.78969 1.25 5.90979 1.25 8.15V10.85C1.25 13.0902 1.25 14.2103 1.68597 15.066C2.06947 15.8186 2.68139 16.4305 3.43404 16.814C4.28969 17.25 5.40979 17.25 7.65 17.25H10.35C12.5902 17.25 13.7103 17.25 14.566 16.814C15.3186 16.4305 15.9305 15.8186 16.314 15.066C16.75 14.2103 16.75 13.0902 16.75 10.85V8.15C16.75 5.90979 16.75 4.78969 16.314 3.93404C15.9305 3.18139 15.3186 2.56947 14.566 2.18597C13.7103 1.75 12.5902 1.75 10.35 1.75H7.65Z"
              style="fill: var(--black-to-white)"
              fill-opacity="0.2"
            />
            <path
              d="M17.9999 7.75V10.5C17.9999 13.3003 17.9999 14.7004 17.4549 15.77C16.9755 16.7108 16.2106 17.4757 15.2698 17.955C14.2003 18.5 12.8001 18.5 9.99988 18.5H7.25C7.25 19.1967 7.25 19.5451 7.29329 19.8369C7.55182 21.5797 8.92025 22.9482 10.6631 23.2067C10.9549 23.25 11.3033 23.25 12 23.25H16.35C18.5902 23.25 19.7103 23.25 20.566 22.814C21.3186 22.4305 21.9305 21.8186 22.314 21.066C22.75 20.2103 22.75 19.0902 22.75 16.85V12.5001C22.75 11.8033 22.75 11.4549 22.7067 11.163C22.4481 9.42023 21.0798 8.05186 19.337 7.79331C19.0451 7.75 18.6967 7.75 17.9999 7.75Z"
              style="fill: var(--black-to-white)"
              fill-opacity="0.2"
            />
          </svg>
        </div>
        <div class="dataBlock" @click="copyText" v-if="cardData.number != '0' && cardData">
          <div class="blockInfo">
            <p class="blockHead">{{ !isCard ? $t("depositCardAddress") : $t("depositCardPhone") }}</p>
            <p class="blockValue">{{ cardData.number }}</p>
          </div>
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.65 1.75C5.40979 1.75 4.28969 1.75 3.43404 2.18597C2.68139 2.56947 2.06947 3.18139 1.68597 3.93404C1.25 4.78969 1.25 5.90979 1.25 8.15V10.85C1.25 13.0902 1.25 14.2103 1.68597 15.066C2.06947 15.8186 2.68139 16.4305 3.43404 16.814C4.28969 17.25 5.40979 17.25 7.65 17.25H10.35C12.5902 17.25 13.7103 17.25 14.566 16.814C15.3186 16.4305 15.9305 15.8186 16.314 15.066C16.75 14.2103 16.75 13.0902 16.75 10.85V8.15C16.75 5.90979 16.75 4.78969 16.314 3.93404C15.9305 3.18139 15.3186 2.56947 14.566 2.18597C13.7103 1.75 12.5902 1.75 10.35 1.75H7.65Z"
              style="fill: var(--black-to-white)"
              fill-opacity="0.2"
            />
            <path
              d="M17.9999 7.75V10.5C17.9999 13.3003 17.9999 14.7004 17.4549 15.77C16.9755 16.7108 16.2106 17.4757 15.2698 17.955C14.2003 18.5 12.8001 18.5 9.99988 18.5H7.25C7.25 19.1967 7.25 19.5451 7.29329 19.8369C7.55182 21.5797 8.92025 22.9482 10.6631 23.2067C10.9549 23.25 11.3033 23.25 12 23.25H16.35C18.5902 23.25 19.7103 23.25 20.566 22.814C21.3186 22.4305 21.9305 21.8186 22.314 21.066C22.75 20.2103 22.75 19.0902 22.75 16.85V12.5001C22.75 11.8033 22.75 11.4549 22.7067 11.163C22.4481 9.42023 21.0798 8.05186 19.337 7.79331C19.0451 7.75 18.6967 7.75 17.9999 7.75Z"
              style="fill: var(--black-to-white)"
              fill-opacity="0.2"
            />
          </svg>
        </div>
        <div class="dataBlock" v-if="isCard && cardData.block_card.fio_card != '0'" @click="copyText">
          <div class="blockInfo">
            <p class="blockHead">{{ $t("depositCardFIO") }}</p>
            <p class="blockValue">{{ cardData.block_card.fio_card }}</p>
          </div>
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.65 1.75C5.40979 1.75 4.28969 1.75 3.43404 2.18597C2.68139 2.56947 2.06947 3.18139 1.68597 3.93404C1.25 4.78969 1.25 5.90979 1.25 8.15V10.85C1.25 13.0902 1.25 14.2103 1.68597 15.066C2.06947 15.8186 2.68139 16.4305 3.43404 16.814C4.28969 17.25 5.40979 17.25 7.65 17.25H10.35C12.5902 17.25 13.7103 17.25 14.566 16.814C15.3186 16.4305 15.9305 15.8186 16.314 15.066C16.75 14.2103 16.75 13.0902 16.75 10.85V8.15C16.75 5.90979 16.75 4.78969 16.314 3.93404C15.9305 3.18139 15.3186 2.56947 14.566 2.18597C13.7103 1.75 12.5902 1.75 10.35 1.75H7.65Z"
              style="fill: var(--black-to-white)"
              fill-opacity="0.2"
            />
            <path
              d="M17.9999 7.75V10.5C17.9999 13.3003 17.9999 14.7004 17.4549 15.77C16.9755 16.7108 16.2106 17.4757 15.2698 17.955C14.2003 18.5 12.8001 18.5 9.99988 18.5H7.25C7.25 19.1967 7.25 19.5451 7.29329 19.8369C7.55182 21.5797 8.92025 22.9482 10.6631 23.2067C10.9549 23.25 11.3033 23.25 12 23.25H16.35C18.5902 23.25 19.7103 23.25 20.566 22.814C21.3186 22.4305 21.9305 21.8186 22.314 21.066C22.75 20.2103 22.75 19.0902 22.75 16.85V12.5001C22.75 11.8033 22.75 11.4549 22.7067 11.163C22.4481 9.42023 21.0798 8.05186 19.337 7.79331C19.0451 7.75 18.6967 7.75 17.9999 7.75Z"
              style="fill: var(--black-to-white)"
              fill-opacity="0.2"
            />
          </svg>
        </div>
      </div>
      <div class="checkPayment">
        <button class="timeAcceptButton" @click="checkPayment">
          <span class="loader" v-if="isLoader"></span>
          <span v-else>{{ $t("depositCardCheckPayment") }}</span>
        </button>
        <p v-if="timerMinutes == 0 && timerSeconds == 0">{{ $t("timeIsOut") }}</p>
        <div v-else>
          <p v-if="this.$store.getters.getLanguage == 'RU'">
            {{ $t("depositCardRemaining") }} <span>{{ timerMinutes }} {{ $t("depositCardMinutes") }} {{ timerSeconds }} {{ $t("depositCardSeconds") }}</span>
          </p>
          <p v-else>
            <span>{{ timerMinutes }} {{ $t("depositCardMinutes") }} {{ timerSeconds }} {{ $t("depositCardSeconds") }}</span> {{ $t("depositCardRemaining") }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <Transition name="fade">
    <NotifyComponent :timely="false" :duration="3" :notify="notifyText" v-if="isShowNotify" @closeNotify="isShowNotify = false" />
  </Transition>
</template>

<script>
import { BackButton } from "vue-tg";
import NotifyComponent from "./NotifyComponent.vue";
import axios from "axios";
import { UserManager } from "@/utils/userManager";
import { translateApiError } from "@/utils/apiErrors";
export default {
  name: "DepositComponent",
  data() {
    return {
      activeMode: null,
      currency: "",
      isCard: true,
      selectedAmount: "",
      isCardData: false,
      isDepositViaTp: false,
      depositViaTpData: null,
      cardData: null,
      ru: "ru",
      notifyText: "",
      isShowNotify: false,
      timerMinutes: 5,
      timerSeconds: 0,
      isLoader: false,
      timer: null,

      user: null,
      botId: null,
      qrLoading: false,
      qrError: false,
      qrPollInterval: null,
      qrPollAttempts: 0,
      maxQrPollAttempts: 60, // Максимум 60 попыток (60 секунд)
      selectedTypeCard: null,
      bankStepConfirmed: false,
      bankOptions: [
        { value: 'sber', label: 'bankCardSber' },
        { value: 'tinkoff', label: 'bankCardTinkoff' },
        { value: 'alfa', label: 'bankCardAlfa' },
        { value: 'vtb', label: 'bankCardVtb' },
        { value: 'other', label: 'bankCardOther' },
      ],
    };
  },
  computed: {
    needBankSelection() {
      // Выбор банка только для карты РФ (RUB)
      return this.isCard && this.currency === 'RUB';
    },
  },
  methods: {
    openDepositViaTpLink() {
      const url = this.depositViaTpData?.tp_url;
      if (!url) return;
      if (window.Telegram?.WebApp?.openTelegramLink) {
        window.Telegram.WebApp.openTelegramLink(url);
      } else {
        window.open(url, "_blank");
      }
    },
    goBack() {
      window.history.back();
    },
    confirmBankAndGoToAmount() {
      if (this.selectedTypeCard) this.bankStepConfirmed = true;
    },
    goPayment() {
      console.log(this.activeMode);
      if (this.isLoader) return this.showNotify(this.$t("pleaseWait"));
      else if (this.selectedAmount.length == 0) return this.showNotify(this.$t("emptyArea"));
      this.isLoader = true;

      const payload = {
        user_id: this.user.id,
        bot_id: this.botId,
        currency: this.isCard ? this.currency : "RUB",
        amount: Number(this.selectedAmount),
        method: this.activeMode.includes("card") ? "card" : this.activeMode.includes("sbp") ? "sbp" : this.activeMode,
      };
      if (this.needBankSelection && this.selectedTypeCard) {
        payload.type_card = this.selectedTypeCard;
      }
      axios
        .post(`${window.location.origin}/deposit/make`, payload)
        .then((res) => {
          console.log(res);
          this.isLoader = false;
          if (res.data && res.data.code === "deposit-via-tp") {
            this.isDepositViaTp = true;
            this.depositViaTpData = res.data;
            return;
          }
          this.cardData = res.data;
          this.isCardData = true;
          this.startTimer();

          // Если это SBP и QR-код не пришел сразу, начинаем опрос
          if (this.activeMode?.includes("sbp")) {
            // Проверяем наличие QR-кода в разных местах ответа
            const qrImage = res.data.sbp_qr || res.data.block_sbp?.qr_image;

            if (qrImage) {
              // QR-код уже готов
              this.cardData.sbp_qr = qrImage;
              this.qrLoading = false;
              this.qrError = false;
            } else {
              // QR-код еще не готов, начинаем опрос
              this.qrLoading = true;
              this.qrError = false;
              this.qrPollAttempts = 0;
              this.startQrPolling();
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.isLoader = false;
          this.showNotify(translateApiError(this.$t.bind(this), err.response?.data?.detail));
        });
    },
    changeActive() {
      this.activeMode == "deposit" ? (this.activeMode = "withdraw") : (this.activeMode = "deposit");
    },
    copyText(event) {
      let info = event.target.closest(".dataBlock").querySelector(".blockValue").innerText;
      navigator.clipboard.writeText(info).then(() => {
        this.showNotify(this.$t("notifyCopyText"));
      });
    },
    showNotify(text) {
      this.notifyText = text;
      this.isShowNotify = true;
    },
    closeNotify() {
      this.isShowNotify = false;
    },
    initializeUser() {
      const storedUser = this.$store.getters.getTgUserData;
      const storedBotId = this.$store.getters.getBotId;
      if (storedUser && storedBotId) {
        this.user = storedUser;
        this.botId = storedBotId;
      } else {
        const userContext = UserManager.getFullUserContext();
        this.user = userContext.user;
        this.botId = userContext.botId;
        this.$store.commit("setTgUserData", this.user);
        this.$store.commit("setBotId", this.botId);
      }
    },
    checkPayment() {
      if (this.isLoader) return this.showNotify(this.$t("pleaseWait"));
      this.isLoader = true;
      axios
        .post(`${window.location.origin}/deposit/check`, {
          user_id: this.user.id,
          bot_id: this.botId,
          id_pay: this.cardData.id_pay.toString(),
        })
        .then((res) => {
          console.log(res);
          if (res.data.success) {
            this.showNotify(this.$t("paymentProcessed"));
            this.isLoader = false;
            setTimeout(() => {
              window.location.href = "/";
            }, 5000);
          }
        })
        .catch((err) => {
          console.log(err);
          this.isLoader = false;
          this.showNotify(translateApiError(this.$t.bind(this), err.response?.data?.detail));
        });
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.timerSeconds - 1 == -1) {
          this.timerMinutes -= 1;
          this.timerSeconds = 60;
        }
        this.timerSeconds -= 1;
        if (this.timerMinutes == 0 && this.timerSeconds == 0) clearInterval(this.timer);
      }, 1000);
    },
    getCurrencyName(cur) {
      switch (cur) {
        case "BTC":
          return "Bitcoin";
        case "ETH":
          return "Ethereum";
        case "USDT":
          return "Tether";
        case "sbp":
          return this.$t("sbp");
      }
    },
    getImgName(cur) {
      switch (cur) {
        case "RUB":
          return "ru";
        case "UAH":
          return "ua";
        case "KZT":
          return "kz";
        case "BTC":
          return "bitcoin";
        case "ETH":
          return "ethereum";
        case "USDT":
          return "tether";
        case "sbp":
          return "sbp";
      }
    },
    startQrPolling() {
      // Очищаем предыдущий интервал, если есть
      if (this.qrPollInterval) {
        clearInterval(this.qrPollInterval);
      }

      // Начинаем опрос статуса QR-кода каждую секунду
      this.qrPollInterval = setInterval(() => {
        this.checkQrStatus();
      }, 1000);

      // Первая проверка сразу
      this.checkQrStatus();
    },
    checkQrStatus() {
      if (!this.cardData || !this.cardData.id_pay) {
        this.stopQrPolling();
        this.qrError = true;
        this.qrLoading = false;
        return;
      }

      this.qrPollAttempts++;

      // Если превысили максимальное количество попыток, считаем ошибкой
      if (this.qrPollAttempts > this.maxQrPollAttempts) {
        this.stopQrPolling();
        this.qrError = true;
        this.qrLoading = false;
        return;
      }

      axios
        .post(`${window.location.origin}/deposit/qr-status`, {
          id_pay: this.cardData.id_pay.toString(),
        })
        .then((res) => {
          if (res.data.qr_ready && res.data.qr_image) {
            // QR-код готов
            this.cardData.sbp_qr = res.data.qr_image;
            // Обновляем sbp_link, если он пришел
            if (res.data.sbp_link) {
              this.cardData.sbp_link = res.data.sbp_link;
            }
            this.stopQrPolling();
            this.qrLoading = false;
            this.qrError = false;
          } else if (res.data.error) {
            // Ошибка создания QR-кода
            this.stopQrPolling();
            this.qrError = true;
            this.qrLoading = false;
          }
          // Если qr_ready = false и error = null, значит еще создается - продолжаем опрос
        })
        .catch((err) => {
          console.error("Ошибка при проверке статуса QR-кода:", err);
          // Не останавливаем опрос при ошибке запроса, продолжаем попытки
        });
    },
    stopQrPolling() {
      if (this.qrPollInterval) {
        clearInterval(this.qrPollInterval);
        this.qrPollInterval = null;
      }
    },
    openSbpLink() {
      if (this.cardData && this.cardData.sbp_link) {
        window.open(this.cardData.sbp_link, "_blank");
      }
    },
  },
  beforeUnmount() {
    // Очищаем интервалы при размонтировании компонента
    this.stopQrPolling();
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  mounted() {
    this.activeMode = this.$route.params.id;
    this.activeMode.includes("card") ? ((this.currency = this.activeMode.split("_")[1].toUpperCase()), (this.isCard = true)) : ((this.currency = this.activeMode.toUpperCase()), (this.isCard = false));
    this.activeMode.includes("sbp") ? (this.currency = "sbp") : null;
    this.initializeUser();
  },
  components: { BackButton, NotifyComponent },
};
</script>

<style scoped>
.home {
  padding: 5% 3% 5% 3%;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  background-color: var(--background-color);
  height: 100vh;
  max-width: 100vw;
}
.headDeposit {
  display: flex;
  gap: 10px;
  align-items: center;
}
.headDeposit p {
  font-size: 17px;
}
.depositBlock {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.bankSelectLabel {
  color: var(--text-color1);
  margin-bottom: 4px;
  font-size: 15px;
}
.bankOption {
  background-color: var(--second-color);
  border-radius: 10px;
  padding: 13px;
  cursor: pointer;
  color: var(--text-color1);
  border: 2px solid transparent;
  transition: border-color 0.2s;
}
.bankOption.active {
  border-color: #007aff;
}
.timeInput {
  width: 100%;
  background-color: var(--button-background);
  border-radius: 10px;
  border: 0;
  padding: 13px;
  font-size: 17px;
  font-weight: 400;
  outline: none;
  color: var(--text-color1);
}
.timeAcceptButton {
  background-color: #007aff;
  border-radius: 10px;
  padding: 15px;
  color: var(--button-text-color);
  border: 0;
  font-size: 16px;
  font-family: "SF Pro Text Bold";
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.3s;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.timeAcceptButton.active {
  opacity: 1;
}
.cardData {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.dataBlock {
  background-color: var(--second-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-radius: 10px;
}
.blockInfo {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 90%;
}
.blockHead {
  color: #808080;
  font-size: 15px;
}
.blockValue {
  font-size: 17px;
  color: var(--black-to-white);
  word-wrap: break-word;
  white-space: nowrap;
  overflow: hidden;
  mask-image: linear-gradient(to right, black 80%, transparent 100%);
  -webkit-mask-image: linear-gradient(to right, black 80%, transparent 100%);
}
.checkPayment {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.checkPayment p {
  color: #8d8d8e;
}
.checkPayment p span {
  color: #bababb;
}
.loader {
  border: 3px solid white;
  border-bottom-color: transparent;
  width: 20px;
  height: 20px;
  display: flex;
  border-radius: 50%;
  animation: rotation 1s linear infinite;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.depositViaTp {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 10px 0;
}
.depositViaTpMessage {
  color: var(--text-color1);
  font-size: 15px;
  line-height: 1.4;
  text-align: left;
}
.depositViaTpAmount {
  color: #8d8d8e;
  font-size: 14px;
}
.depositViaTpAmount span {
  color: var(--black-to-white);
  font-size: 17px;
}
.qrBlock {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding: 20px;
  flex-direction: column;
}
.qrContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  width: 100%;
}
.qrLoading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
.qrLoader {
  width: 60px;
  height: 60px;
  border: 4px solid var(--button-background);
  border-top: 4px solid #007aff;
  border-radius: 50%;
  animation: rotation 1s linear infinite;
}
.qrLoadingText {
  color: var(--text-color1);
  font-size: 16px;
  text-align: center;
}
.qrError {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  text-align: center;
}
.errorIcon {
  width: 64px;
  height: 64px;
}
.qrErrorText {
  color: #ff3b30;
  font-size: 18px;
  font-weight: 600;
}
.qrErrorSupport {
  color: var(--text-color2);
  font-size: 14px;
}
.qrImage {
  max-width: min(80vw, 400px);
  max-height: min(80vh, 400px);
  width: auto;
  height: auto;
  border-radius: 10px;
  object-fit: contain;
}
.sbpLinkButton {
  background-color: #007aff;
  border-radius: 10px;
  padding: 12px 20px;
  color: var(--button-text-color);
  border: 0;
  font-size: 16px;
  font-family: "SF Pro Text Bold";
  cursor: pointer;
  transition: opacity 0.3s;
  width: 100%;
  max-width: 400px;
}
.sbpLinkButton:hover {
  opacity: 0.8;
}
.sbpLinkButton:active {
  opacity: 0.6;
}
</style>
